// frontend/src/layouts/AdminLayout.tsx
import { Outlet, NavLink, Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { 
  LayoutDashboard, 
  School, 
  Users, 
  BookOpen, 
  Coins, 
  Brain, 
  TrendingUp, 
  Receipt, 
  Settings, 
  Bot, 
  Mail, 
  ArrowLeft, 
  LogOut, 
  Shield 
} from 'lucide-react';
import { authService } from '../services/auth.service';
import { useAuthStore } from '../store/authStore';
import '../styles/admin.css';

const FULL_ADMIN_NAV = [
  { path: '/admin',                  label: 'Genel Bakış',       icon: LayoutDashboard, end: true },
  { path: '/admin/school',           label: 'Okul Dashboard',    icon: School },
  { path: '/admin/users',            label: 'Kullanıcılar',      icon: Users },
  { path: '/admin/courses',          label: 'Kurs Yönetimi',     icon: BookOpen },
  { path: '/admin/coin-shop',        label: 'Coin Mağazası',     icon: Coins },
  { path: '/admin/student-analytics',label: 'Öğrenci Analitiği', icon: Brain },
  { path: '/admin/revenue',          label: 'Revenue',            icon: TrendingUp },
  { path: '/admin/finance',          label: 'Finans & Sipariş',  icon: Receipt },
  { path: '/admin/plans',            label: 'Plan & Feature',    icon: Settings },
  { path: '/admin/ai-usage',         label: 'AI Kullanımı',      icon: Bot },
  { path: '/admin/messages',         label: 'İletişim Mesajları', icon: Mail },
];

const SCHOOL_ADMIN_NAV = [
  { path: '/admin/school',           label: 'Okul Paneli',       icon: School },
  { path: '/admin/users',            label: 'Kullanıcılar',      icon: Users },
  { path: '/admin/courses',          label: 'Kurs Yönetimi',     icon: BookOpen },
  { path: '/admin/student-analytics',label: 'Öğrenci Analitiği', icon: Brain },
  { path: '/admin/ai-usage',         label: 'AI Kullanımı',      icon: Bot },
  { path: '/admin/plans',            label: 'Plan & Özellikler', icon: Settings },
  { path: '/admin/coin-shop',        label: 'Coin Mağazası',     icon: Coins },
  { path: '/admin/revenue',          label: 'Finans & Fatura',   icon: TrendingUp },
];

export function AdminLayout() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const profile = useAuthStore((s) => s.profile);

  const isSchoolRole = profile?.role === 'school';
  const navItems = isSchoolRole ? SCHOOL_ADMIN_NAV : FULL_ADMIN_NAV;

  async function handleSignOut() {
    await authService.signOut();
    navigate('/auth');
  }

  return (
    <div className="admin-layout">
      <button
        className={`app-mobile-menu-btn${sidebarOpen ? ' is-open' : ''}`}
        onClick={() => setSidebarOpen(prev => !prev)}
        aria-label={sidebarOpen ? 'Menüyü kapat' : 'Menüyü aç'}
        aria-expanded={sidebarOpen}
      >
        {sidebarOpen ? '✕' : '☰'}
      </button>
      {sidebarOpen && <div className="app-sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}

      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-brand">
          {isSchoolRole ? <School size={22} className="text-teal" /> : <Shield size={22} className="text-teal" />}
          <span>{isSchoolRole ? 'Okul Yönetim Paneli' : 'Admin Panel'}</span>
        </div>
        <nav>
          {navItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <NavLink
                key={item.path} to={item.path} end={item.end}
                className={({ isActive }) => `admin-sidebar-item ${isActive ? 'active' : ''}`}
                onClick={() => setSidebarOpen(false)}
              >
                <IconComponent size={18} /> <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="admin-sidebar-footer">
          <Link to="/dashboard" className="admin-sidebar-item">
            <ArrowLeft size={18} /> <span>Öğrenci Paneline Dön</span>
          </Link>
          <button className="admin-sidebar-item logout" onClick={handleSignOut}>
            <LogOut size={18} /> <span>Çıkış Yap</span>
          </button>
        </div>
      </aside>

      <main className="admin-main-content"><Outlet /></main>
    </div>
  );
}
